import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          setTimeout(() => navigate(data.kind === "ad" ? "/organizer?promoted=1" : `/bookings/${data.ref_id}`), 1200);
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* retry */ }
      if (++tries.current < 12) t = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(t);
  }, [sessionId, navigate]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 text-center">
      {state === "checking" && (<>
        <div className="h-12 w-12 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" />
        <div data-testid="payment-checking" className="mt-6 font-display text-2xl font-bold text-zinc-50">Confirming your payment…</div>
        <p className="mt-2 text-sm text-zinc-400">Hang tight, this takes a couple of seconds.</p>
      </>)}
      {state === "paid" && (<>
        <CheckCircle2 className="h-14 w-14 text-amber-400" />
        <div data-testid="payment-paid" className="mt-6 font-display text-2xl font-bold text-zinc-50">Paid! Taking you to your ticket…</div>
      </>)}
      {(state === "error" || state === "timeout") && (<>
        <XCircle className="h-14 w-14 text-punch-500" />
        <div data-testid="payment-error" className="mt-6 font-display text-2xl font-bold text-zinc-50">{state === "timeout" ? "Still processing" : "Payment didn't go through"}</div>
        <p className="mt-2 text-sm text-zinc-400">{state === "timeout" ? "Check My Tickets in a minute — we'll email your QR ticket as soon as it clears." : "No money was taken. You can try again."}</p>
        <Link to="/my-bookings" className="mt-6 rounded-full bg-amber-500 px-6 py-2 text-sm font-bold uppercase tracking-widest text-zinc-950">My tickets</Link>
      </>)}
    </div>
  );
}
